import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=66bcc144&lang=pug&"
import script from "./Matrix.vue?vue&type=script&lang=js&"
export * from "./Matrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports